import { Component, DestroyRef, effect, inject, input, InputSignal, Renderer2 } from "@angular/core";
import { PORTAL_PRODUCT_SERVICE_TOKEN } from "../shared";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { isKnownProductKey, ProductKey } from "gast-common-ng2";

@Component({
  selector: "portal-theme-provider",
  templateUrl: "./theme-provider.component.html",
  styleUrl: "./theme-provider.component.scss",
  imports: [],
  standalone: true,
})
export class ThemeProviderComponent {
  readonly #portalProductService = inject(PORTAL_PRODUCT_SERVICE_TOKEN, { optional: true });
  readonly #renderer = inject(Renderer2);
  readonly #destroyRef = inject(DestroyRef);
  readonly currentProduct: InputSignal<ProductKey | undefined> = input<ProductKey>();

  #currentProductSuffix: string | undefined;

  constructor() {
    effect(() => {
      if (this.currentProduct()) {
        this.#setAppTheme(this.currentProduct()!);
      }
    });
    if (this.#portalProductService) {
      this.#portalProductService.selectedProduct$
        .pipe(takeUntilDestroyed(this.#destroyRef))
        .subscribe((product: ProductKey) => this.#setAppTheme(product));
    }
  }

  #setAppTheme(product: ProductKey) {
    if (!isKnownProductKey(product)) {
      throw new Error(`Cannot set app theme for unknown product: ${product}`);
    }
    this.#resetThemingClass();
    this.#currentProductSuffix = this.#mapToProductSuffix(product);
    this.#setThemingClass();
  }

  #resetThemingClass() {
    if (this.#currentProductSuffix) {
      this.#renderer.removeClass(document.body, `skin-${this.#currentProductSuffix}`);
    }
  }

  #mapToProductSuffix(product: ProductKey): string {
    if (product === "DIGITAL_TESTAS") {
      return "testas";
    } else {
      return product.toLowerCase();
    }
  }

  #setThemingClass() {
    if (this.#currentProductSuffix) {
      this.#renderer.addClass(document.body, `skin-${this.#currentProductSuffix}`);
    }
  }
}
